import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Button } from '../../ui/button';
import { CreditCard } from 'lucide-react';
import { toast } from 'sonner';
import { getPaymentMethods, savePaymentMethods } from '../../../lib/api';
import MediaUpload from '../MediaUpload';

export default function PaymentMethodsSection() {
  const [pm, setPm] = useState({ bank_name: '', account_holder: '', account_number: '', ifsc: '', upi_id: '', qr_image: '', notes: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getPaymentMethods().then((d) => setPm({ bank_name: '', account_holder: '', account_number: '', ifsc: '', upi_id: '', qr_image: '', notes: '', ...(d || {}) })).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try { await savePaymentMethods(pm); toast.success('Payment methods saved'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
    finally { setSaving(false); }
  };
  const f = (k) => ({ value: pm[k] || '', onChange: (e) => setPm({ ...pm, [k]: e.target.value }), className: 'bg-zinc-950 border-zinc-800 text-zinc-100' });

  if (loading) return <div className="text-zinc-500 p-6">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="payment-methods-section">
      <Card className="bg-zinc-900 border-zinc-800">
        <CardHeader>
          <CardTitle className="text-zinc-100 flex items-center gap-2"><CreditCard size={18} /> Payment Methods for Wallet Deposits</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-zinc-400 text-sm">Users will see these details when depositing money. They send payment then upload a screenshot for your review.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div><Label className="text-zinc-300 text-xs">Bank Name</Label><Input {...f('bank_name')} data-testid="pm-bank-input" /></div>
            <div><Label className="text-zinc-300 text-xs">Account Holder</Label><Input {...f('account_holder')} data-testid="pm-holder-input" /></div>
            <div><Label className="text-zinc-300 text-xs">Account Number</Label><Input {...f('account_number')} data-testid="pm-account-input" /></div>
            <div><Label className="text-zinc-300 text-xs">IFSC / SWIFT</Label><Input {...f('ifsc')} data-testid="pm-ifsc-input" /></div>
            <div className="md:col-span-2"><Label className="text-zinc-300 text-xs">UPI ID</Label><Input {...f('upi_id')} placeholder="acme@upi" data-testid="pm-upi-input" /></div>
            <div className="md:col-span-2">
              <Label className="text-zinc-300 text-xs">QR Code Image</Label>
              <MediaUpload value={pm.qr_image} onChange={(v) => setPm({ ...pm, qr_image: v })} accept="image" previewClass="h-32 w-32" testid="pm-qr" />
            </div>
            <div className="md:col-span-2">
              <Label className="text-zinc-300 text-xs">Notes (optional, e.g. instructions)</Label>
              <textarea {...f('notes')} rows={3} className="w-full mt-1 px-3 py-2 bg-zinc-950 border border-zinc-800 rounded-md text-sm text-zinc-100" />
            </div>
          </div>
          <div className="flex justify-end pt-2">
            <Button onClick={save} disabled={saving} className="bg-[color:var(--gold)] text-black font-bold" data-testid="pm-save-btn">{saving ? 'Saving…' : 'Save'}</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
